import * as i0 from '@angular/core';
import { Directive, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class UiIconDirective {
    constructor() {
        this.sdIcon = true;
    }
}
UiIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: UiIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
UiIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: UiIconDirective, selector: "[sdUiIcon], sd-ui-icon", host: { properties: { "class.sd-icon": "this.sdIcon" } }, exportAs: ["sdUiIcon"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: UiIconDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[sdUiIcon], sd-ui-icon',
                    exportAs: 'sdUiIcon',
                }]
        }], propDecorators: { sdIcon: [{
                type: HostBinding,
                args: ['class.sd-icon']
            }] } });

class SmartDesignIconModule {
}
SmartDesignIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SmartDesignIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignIconModule, declarations: [UiIconDirective], imports: [CommonModule], exports: [UiIconDirective] });
SmartDesignIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignIconModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UiIconDirective],
                    exports: [UiIconDirective],
                    imports: [CommonModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SmartDesignIconModule, UiIconDirective };
